document.addEventListener("DOMContentLoaded", function () {
  if (!window.hasLoadedRelated) {
    window.hasLoadedRelated = true;

    const relatedProducts = document.querySelector(".js-related-products");
    if (relatedProducts) {
      const url = relatedProducts.getAttribute("data-url");

      fetch(url)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const recommendations = doc.querySelector('.js-related-products');

          if (recommendations) {
            relatedProducts.innerHTML = recommendations.innerHTML;

            if (typeof initializeObservers === "function") {
              initializeObservers();
            }

            if (typeof productGridForm === 'function') productGridForm();
          }
        });
    }
  }
});